import {
    Box,
    Button,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

interface IDeleteProjectDialogProps {
    open: boolean;
    projectName: string;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
}

export default function DeleteProjectDialog({
    open,
    projectName,
    onClose,
    onConfirm,
    isLoading = false,
}: IDeleteProjectDialogProps) {
    const handleClose = () => {
        if (!isLoading) {
            onClose();
        }
    };

    const handleConfirm = () => {
        console.log('handleConfirm вызван, isLoading:', isLoading);
        if (!isLoading) {
            console.log('Вызываем onConfirm');
            onConfirm();
        } else {
            console.log('Удаление уже выполняется, игнорируем клик');
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="delete-project-dialog-title"
            aria-describedby="delete-project-dialog-description"
        >
            <DialogTitle id="delete-project-dialog-title">Удаление проекта</DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-project-dialog-description">
                    <Typography
                        variant="body1"
                        color="primary"
                    >
                        Вы действительно хотите удалить проект &quot;{projectName}&quot;? Это действие нельзя отменить.
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                    disabled={isLoading}
                    autoFocus
                    type="button"
                >
                    Отменить
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleConfirm}
                    disabled={isLoading}
                    type="button"
                >
                    {isLoading ? 'Удаление...' : 'Удалить'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
